(function () {
  'use strict';

  var SELECTORS = {
    container: '.faq-accordion',
    filterBtn: '.faq-accordion__filter-btn',
    item: '.faq-accordion__item',
    answer: '.faq-accordion__answer',
    group: '.faq-accordion__group',
    nav: '#faq-nav',
    navLink: '.faq-nav__link',
  };

  var CLASSES = {
    active: 'faq-accordion__filter-btn--active',
    hiding: 'faq-accordion__item--hiding',
    showing: 'faq-accordion__item--showing',
    navActive: 'faq-nav__link--active',
  };

  function initFaqAccordion() {
    var containers = document.querySelectorAll(SELECTORS.container);
    containers.forEach(setupContainer);
    initStickyNav();
    initSearch();
    initDeepLink();
  }

  function setupContainer(container) {
    setupFilters(container);
    setupSmoothToggle(container);
  }

  /**
   * Topic filter buttons
   */
  function setupFilters(container) {
    var buttons = container.querySelectorAll(SELECTORS.filterBtn);
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var topic = btn.getAttribute('data-topic');

        buttons.forEach(function (b) {
          b.classList.remove(CLASSES.active);
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add(CLASSES.active);
        btn.setAttribute('aria-selected', 'true');

        filterItems(container, topic);
      });
    });
  }

  function filterItems(container, topic) {
    var items = container.querySelectorAll(SELECTORS.item);

    items.forEach(function (item) {
      var topics = item.getAttribute('data-topics') || '';
      var topicList = topics.split(' ');

      if (topic === 'all' || topicList.indexOf(topic) !== -1) {
        item.removeAttribute('hidden');
        item.classList.remove(CLASSES.hiding);
        item.classList.add(CLASSES.showing);
        item.addEventListener(
          'animationend',
          function () {
            item.classList.remove(CLASSES.showing);
          },
          { once: true }
        );
      } else {
        item.open = false;
        item.setAttribute('hidden', '');
        item.classList.remove(CLASSES.showing);
      }
    });

    // Show/hide product group headings based on whether they have visible items
    var groups = container.querySelectorAll(SELECTORS.group);
    groups.forEach(function (group) {
      var visibleItems = group.querySelectorAll(SELECTORS.item + ':not([hidden])');
      if (visibleItems.length === 0) {
        group.setAttribute('hidden', '');
      } else {
        group.removeAttribute('hidden');
      }
    });

    // Update nav visibility to match filtered groups
    updateNavVisibility();
  }

  /**
   * Smooth open/close animation for <details>
   */
  function setupSmoothToggle(container) {
    var items = container.querySelectorAll(SELECTORS.item);

    items.forEach(function (details) {
      var summary = details.querySelector('summary');
      var answer = details.querySelector(SELECTORS.answer);
      if (!summary || !answer) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        if (details.open) {
          closeDetails(details, answer);
        } else {
          openDetails(details, answer);
        }
      });
    });
  }

  function openDetails(details, answer) {
    // Single-open mode: close other open items in the same container
    var container = details.closest(SELECTORS.container);
    if (container && container.getAttribute('data-single-open') === 'true') {
      var openItems = container.querySelectorAll(SELECTORS.item + '[open]');
      openItems.forEach(function (other) {
        if (other !== details) {
          var otherAnswer = other.querySelector(SELECTORS.answer);
          if (otherAnswer) closeDetails(other, otherAnswer);
        }
      });
    }

    details.open = true;
    var height = answer.scrollHeight;
    answer.style.maxHeight = '0px';
    answer.style.opacity = '0';

    requestAnimationFrame(function () {
      answer.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
      answer.style.maxHeight = height + 'px';
      answer.style.opacity = '1';

      answer.addEventListener(
        'transitionend',
        function () {
          answer.style.maxHeight = '';
          answer.style.transition = '';
        },
        { once: true }
      );
    });
  }

  function closeDetails(details, answer) {
    var height = answer.scrollHeight;
    answer.style.maxHeight = height + 'px';
    answer.style.opacity = '1';

    requestAnimationFrame(function () {
      answer.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
      answer.style.maxHeight = '0px';
      answer.style.opacity = '0';

      answer.addEventListener(
        'transitionend',
        function () {
          details.open = false;
          answer.style.maxHeight = '';
          answer.style.opacity = '';
          answer.style.transition = '';
        },
        { once: true }
      );
    });
  }

  /* ═══════════════════════════════════════════════════════════════════
     STICKY NAV — Scroll spy + smooth scroll + nav visibility
     ═══════════════════════════════════════════════════════════════════ */

  function initStickyNav() {
    var nav = document.querySelector(SELECTORS.nav);
    if (!nav) return;

    var links = nav.querySelectorAll(SELECTORS.navLink);
    if (!links.length) return;

    // Smooth scroll on click
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var targetId = link.getAttribute('data-faq-target');
        var target = document.getElementById(targetId);
        if (!target) return;

        // Calculate offset for sticky elements
        var offset = getScrollOffset();
        var targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: targetTop,
          behavior: 'smooth',
        });

        // Update active state immediately
        setActiveLink(link);

        // On mobile, scroll the nav to show the active pill
        if (window.innerWidth < 750) {
          link.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });

    // Scroll spy using IntersectionObserver
    setupScrollSpy(links);
  }

  function getScrollOffset() {
    // Account for sticky header + mobile nav bar
    var offset = 140; // Default for desktop (header + some breathing room)
    if (window.innerWidth < 750) {
      var nav = document.querySelector(SELECTORS.nav);
      offset = nav ? nav.offsetHeight + 20 : 80;
    }
    return offset;
  }

  function setupScrollSpy(links) {
    var groups = document.querySelectorAll(SELECTORS.group);
    if (!groups.length) return;

    // Use a throttled scroll listener for broad browser support
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          updateActiveFromScroll(links, groups);
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Initial check
    updateActiveFromScroll(links, groups);
  }

  function updateActiveFromScroll(links, groups) {
    var offset = getScrollOffset() + 40;
    var activeId = null;

    // Find the group whose top is closest to (but above) the scroll offset line
    for (var i = groups.length - 1; i >= 0; i--) {
      var group = groups[i];
      if (group.hasAttribute('hidden')) continue;
      var rect = group.getBoundingClientRect();
      if (rect.top <= offset) {
        activeId = group.id;
        break;
      }
    }

    // If nothing found (user at top), activate first visible group
    if (!activeId) {
      for (var j = 0; j < groups.length; j++) {
        if (!groups[j].hasAttribute('hidden')) {
          activeId = groups[j].id;
          break;
        }
      }
    }

    if (activeId) {
      links.forEach(function (link) {
        if (link.getAttribute('data-faq-target') === activeId) {
          setActiveLink(link);
        }
      });
    }
  }

  function setActiveLink(activeLink) {
    var nav = activeLink.closest(SELECTORS.nav);
    if (!nav) return;

    nav.querySelectorAll(SELECTORS.navLink).forEach(function (link) {
      link.classList.remove(CLASSES.navActive);
    });
    activeLink.classList.add(CLASSES.navActive);
  }

  /**
   * Hide nav items whose corresponding group is hidden (from topic filtering)
   */
  function updateNavVisibility() {
    var nav = document.querySelector(SELECTORS.nav);
    if (!nav) return;

    var navItems = nav.querySelectorAll('.faq-nav__item');
    navItems.forEach(function (navItem) {
      var link = navItem.querySelector(SELECTORS.navLink);
      if (!link) return;
      var targetId = link.getAttribute('data-faq-target');
      var group = document.getElementById(targetId);
      if (group && group.hasAttribute('hidden')) {
        navItem.style.display = 'none';
      } else {
        navItem.style.display = '';
      }
    });
  }

  /* ═══════════════════════════════════════════════════════════════════
     SEARCH — live-filter from 3 characters
     ═══════════════════════════════════════════════════════════════════ */

  function initSearch() {
    var input = document.getElementById('faq-search-input');
    if (!input) return;

    var clearBtn = document.getElementById('faq-search-clear');
    var countEl = document.getElementById('faq-search-count');
    var container = input.closest(SELECTORS.container) || document.querySelector(SELECTORS.container);
    if (!container) return;

    var debounceTimer = null;

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        performSearch(input.value, container, clearBtn, countEl);
      }, 150);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        performSearch('', container, clearBtn, countEl);
        input.focus();
      });
    }
  }

  function performSearch(query, container, clearBtn, countEl) {
    var trimmed = query.trim().toLowerCase();

    // Show/hide clear button
    if (clearBtn) {
      clearBtn.hidden = trimmed.length === 0;
    }

    var items = container.querySelectorAll(SELECTORS.item);
    var groups = container.querySelectorAll(SELECTORS.group);

    // Reset highlights
    items.forEach(function (item) {
      removeHighlights(item);
    });

    // If fewer than 3 characters, show everything and hide count
    if (trimmed.length < 3) {
      items.forEach(function (item) {
        item.removeAttribute('hidden');
        item.classList.remove(CLASSES.hiding);
      });
      groups.forEach(function (group) {
        group.removeAttribute('hidden');
      });
      if (countEl) countEl.hidden = true;
      updateNavVisibility();
      return;
    }

    var visibleCount = 0;

    items.forEach(function (item) {
      var questionEl = item.querySelector('.faq-accordion__question-text');
      var answerEl = item.querySelector('.faq-accordion__answer-content');
      var questionText = questionEl ? questionEl.textContent.toLowerCase() : '';
      var answerText = answerEl ? answerEl.textContent.toLowerCase() : '';

      if (questionText.indexOf(trimmed) !== -1 || answerText.indexOf(trimmed) !== -1) {
        item.removeAttribute('hidden');
        item.classList.remove(CLASSES.hiding);
        visibleCount++;
        // Add highlights
        if (questionEl) highlightText(questionEl, trimmed);
        if (answerEl) highlightText(answerEl, trimmed);
      } else {
        item.open = false;
        item.setAttribute('hidden', '');
        item.classList.remove(CLASSES.showing);
      }
    });

    // Show/hide groups based on visible items
    groups.forEach(function (group) {
      var visibleItems = group.querySelectorAll(SELECTORS.item + ':not([hidden])');
      if (visibleItems.length === 0) {
        group.setAttribute('hidden', '');
      } else {
        group.removeAttribute('hidden');
      }
    });

    // Update count
    if (countEl) {
      countEl.hidden = false;
      countEl.textContent = visibleCount === 0
        ? 'Inga resultat hittades'
        : visibleCount + (visibleCount === 1 ? ' resultat' : ' resultat');
    }

    updateNavVisibility();
  }

  function highlightText(el, query) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var textNodes = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach(function (textNode) {
      var text = textNode.textContent;
      var lowerText = text.toLowerCase();
      var idx = lowerText.indexOf(query);
      if (idx === -1) return;

      var fragment = document.createDocumentFragment();
      var lastIdx = 0;

      while (idx !== -1) {
        if (idx > lastIdx) {
          fragment.appendChild(document.createTextNode(text.substring(lastIdx, idx)));
        }
        var mark = document.createElement('mark');
        mark.className = 'faq-search__highlight';
        mark.textContent = text.substring(idx, idx + query.length);
        fragment.appendChild(mark);
        lastIdx = idx + query.length;
        idx = lowerText.indexOf(query, lastIdx);
      }

      if (lastIdx < text.length) {
        fragment.appendChild(document.createTextNode(text.substring(lastIdx)));
      }

      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  function removeHighlights(el) {
    var marks = el.querySelectorAll('.faq-search__highlight');
    marks.forEach(function (mark) {
      var parent = mark.parentNode;
      parent.replaceChild(document.createTextNode(mark.textContent), mark);
      parent.normalize();
    });
  }

  /* ═══════════════════════════════════════════════════════════════════
     DEEP LINK — Scroll to and open a FAQ item from URL hash
     ═══════════════════════════════════════════════════════════════════ */

  function initDeepLink() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var targetId = hash.substring(1); // Remove the #
    var target = document.getElementById(targetId);

    // Only act on faq-accordion__item elements (not group headings etc.)
    if (!target || !target.classList.contains('faq-accordion__item')) return;

    // Open the details element using the existing smooth open function
    var answer = target.querySelector('.faq-accordion__answer');
    if (answer && !target.open) {
      openDetails(target, answer);
    }

    // Scroll to it after a short delay (let the open animation start)
    setTimeout(function () {
      var offset = getScrollOffset();
      var targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: targetTop, behavior: 'smooth' });

      // Brief highlight pulse so the user spots it
      target.classList.add('faq-accordion__item--highlighted');
      setTimeout(function () {
        target.classList.remove('faq-accordion__item--highlighted');
      }, 2000);
    }, 100);
  }

  // Also handle hash changes (e.g. user clicks a deep link while already on the page)
  window.addEventListener('hashchange', function () {
    initDeepLink();
  });

  /* ═══════════════════════════════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════════════════════════════ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }

  // Re-init when Shopify section is re-rendered in the theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target;
      var container = section.querySelector(SELECTORS.container);
      if (container) setupContainer(container);
      initStickyNav();
    });
  }
})();
